'use strict';

//REGULATIONS
var REGULATION_ACTIVE = 'Normativa activa nuevamente en el sistema';
var REGULATION_INACTIVE = 'Normativa inactiva';